import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=54c797cc&scoped=true&"
import script from "./SearchFilter.vue?vue&type=script&lang=js&"
export * from "./SearchFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=54c797cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c797cc",
  null
  
)

export default component.exports